import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AppLanguage, ExportGuidelinesPayload, GeneralDataDTO, GetPageActionData, HomePage, PageBase, SearchNoResultPlugin, SearchResultPlugin } from '../models';
import { environment } from '../../environments/environment';
import { CmsPage } from '../components/cms-page.component';

@Injectable({ providedIn: 'root' })
export class CmsService {
  private http = inject(HttpClient);

  getOrphan<T = PageBase>(language: string, metaUrl: 'contact' | 'privacy-policy' | 'cookie-policy' | 'search', params?: HttpParams | {
    [param: string]: string | number | boolean | readonly (string | number | boolean)[];
  }) {
    return this.http.get<T>(
      `${environment.apiBaseUrl}/${language}/api/website/page/${metaUrl}`,
      {
        params
      }
    );
  }

  getPage<T extends HomePage | CmsPage>(params: GetPageActionData) {
    return this.http.get<T>(
      `${environment.apiBaseUrl}/${params.language}/api/website/page`,
      params.path.length > 0
        ? {
          params: { path: params.path.join(',') },
        }
        : undefined,
    );
  }

  getGeneral(language: AppLanguage = 'en') {
    return this.http.get<GeneralDataDTO>(
      `${environment.apiBaseUrl}/${language}/api/website/general`,
    );
  }

  postContactForm(formData: FormData) {
    return this.http.post(`${environment.apiBaseUrl}/api/forms/contact`, formData);
  }

  search(language: AppLanguage, params: { query: string }) {
    return this.http.get<PageBase<SearchResultPlugin | SearchNoResultPlugin>>(
      `${environment.apiBaseUrl}/${language}/api/website/page/search`,
      { params }
    );
  }

  exportGuidelines(language: AppLanguage, dto: ExportGuidelinesPayload) {
    return this.http.post(
      `${environment.apiBaseUrl}/${language}/pdf/guidelines`,
      dto,
      { responseType: 'blob' }
    );
  }
}

